/**
 * 扫描配置
 */
import Base from '../../base/Base';
import { ScanScopeType } from './ScanScopeType';

export default class ScanConfig extends Base {
  // 是否启用扫描任务
  enable: boolean = true;
  
  // cron表达式 定时任务用
  cron: string | null = null;
  
  // 扫描磁盘开启范围（全部空间 or 自定义空间）
  scope: ScanScopeType = ScanScopeType.ALL;
  
  // 开启扫描磁盘功能的空间（当 scope 为 CUSTOM 时有效）
  spaceNames: string[] = [];
  
  // 自动清理开关
  autoCleanEnabled: boolean = false;
  
  // 清理多少天之前的文件（0 表示不清理，实际生效时需 autoCleanEnabled 为 true）
  autoCleanDays: number = 0;

  constructor() {
    super();
  }

  assign(obj: any) {
    super.assign(obj);
    
    // 处理 enable 字段，默认 true
    if (obj.enable !== undefined && obj.enable !== null) {
      this.enable = !!obj.enable;
    } else {
      this.enable = true; // 默认开启
    }
    
    // 设置默认 cron 表达式（每天0点）
    if (!this.cron) {
      this.cron = '0 0 * * *';
    }
    
    // 确保 scope 类型正确
    if (obj.scope && Object.values(ScanScopeType).includes(obj.scope)) {
      this.scope = obj.scope;
    } else {
      this.scope = ScanScopeType.ALL;
    }
    
    // 处理 spaceNames
    this.spaceNames = Array.isArray(obj.spaceNames) ? obj.spaceNames : [];
    
    // 处理自动清理开关
    this.autoCleanEnabled = !!obj.autoCleanEnabled;
    
    // 处理 autoCleanDays：确保为数字，若后端返回 null/undefined 则转为 0
    if (obj.autoCleanDays !== undefined && obj.autoCleanDays !== null && !isNaN(Number(obj.autoCleanDays))) {
      this.autoCleanDays = Number(obj.autoCleanDays);
    } else {
      this.autoCleanDays = 0;
    }
  }

  getForm(): any {
    return {
      enable: this.enable,
      scope: this.scope,
      cron: this.cron,
      spaceNames: this.spaceNames,
      autoCleanEnabled: this.autoCleanEnabled,
      autoCleanDays: this.autoCleanDays, // 始终为数字
    };
  }
}